export const dcTableKeys = [
  { name: "GmsPickListCode", key: "pickListCode" },
  { name: "DC Number", key: "dcNo" },
  {
    name: "Created At",
    key: "createdAt",
    isDate: true,
  },
];
